<template>
  <section style="margin: 0px !important">
    <Navbar />
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="searchingGroup"
    >
      <GroupPreview />
    </div>
    <div
      class="previewContainer"
      @click="cancelPreview($event)"
      v-if="creatingGroup"
    >
      <CreateGroup />
    </div>
    <div class="createGroupButton" @click="createGroup">
      <img src="@/assets/createGroupIcon.svg" class="createGroupImg" />
    </div>
    <div class="courseFinderBox">
      <div class="titleRow">
        <span
          class="showBar"
          :class="{
            courseShift: findCourse,
            facultyShift: findFaculty,
            searchShift: findSearch,
          }"
        ></span>
        <div class="findCourseTitle" @click="goToCourse()">Course Finder</div>
        <div class="findCourseTitle" @click="goToFaculty()">Program Finder</div>
        <div class="findCourseTitle" @click="goToSearch()">Advanced Search</div>
      </div>
      <div v-if="findCourse" class="findBox">
        <div class="pathRow">
          <div @click="goToCourse(onSubject)" class="resetPathLink"></div>
          <div v-if="onSubject" class="innerPathRow">
            <div class="pathPointer"></div>
            <div class="pathLink" @click="showCourses(onSubject)">
              {{ onSubject }}
            </div>
          </div>
          <div v-if="onCourse" class="innerPathRow">
            <div class="pathPointer"></div>
            <div class="pathLink" @click="showInfo(onCourse)">
              {{ onCourse }}
            </div>
          </div>
          <p></p>
          <div @click="goToSearch()" class="searchPath"></div>
          <div @click="goToSearch()" class="restOfPath">Search CourseLnk</div>
        </div>
        <div class="finderRow">
          <div class="courseFinderColumn rightBorder">
            <p class="finderTitle">Subject</p>
            <div class="finderScrollBox" :class="{ isWindow: isWindows }">
              <ul class="finderList">
                <li
                  class="finderComponent"
                  :class="{ onComponent: onSubject == subject.name }"
                  @click="showCourses(subject.name)"
                  v-for="subject in subjects"
                  :key="subject.id"
                >
                  <p>
                    {{ subject.name }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div
            class="courseFinderColumn rightBorder"
            :class="{ isWindow: isWindows }"
          >
            <p class="finderTitle">Course</p>
            <div class="finderScrollBox" :class="{ isWindow: isWindows }">
              <ul class="finderList">
                <li
                  class="finderComponent"
                  :class="{ onComponent: onCourse == course.name }"
                  @click="showInfo(course)"
                  v-for="course in courses"
                  :key="course.id"
                >
                  <p>
                    {{ course.name }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="courseFinderColumn" :class="{ isWindow: isWindows }">
            <p class="finderTitle">Info</p>
            <div class="showCourse" v-if="specificCourse">
              <img
                class="courseImage"
                :src="this.specificCourse.profileImage"
              />
              <p>{{ specificCourse.name }}</p>
              <p>{{ specificCourse.userCount }} members</p>
              <button class="joinButton" @click="joinGroup(specificCourse)">
                Join Group
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="findFaculty" class="findBox">
        <div class="pathRow">
          <div @click="goToFaculty()" class="resetPathLink"></div>
          <div v-if="onFaculty" class="innerPathRow">
            <div class="pathPointer"></div>
            <div class="pathLink" @click="showCourses(onSubject)">
              {{ onFaculty }}
            </div>
          </div>
          <div @click="goToSearch()" class="searchPath"></div>
          <div @click="goToSearch()" class="restOfPath">Search CourseLnk</div>
        </div>

        <div class="finderRow">
          <div
            class="courseFinderColumn rightBorder"
            :class="{ isWindow: isWindows }"
          >
            <p class="finderTitle">Program</p>
            <div class="finderScrollBox" :class="{ isWindow: isWindows }">
              <ul class="finderList">
                <li
                  class="finderComponent"
                  :class="{ onComponent: onFaculty == faculty.name }"
                  @click="showFacultyInfo(faculty)"
                  v-for="faculty in faculties"
                  :key="faculty.id"
                >
                  <p>
                    {{ faculty.name }}
                  </p>
                </li>
              </ul>
            </div>
          </div>

          <div class="bigFinderColumn">
            <p class="finderTitle">Info</p>
            <div class="showCourse" v-if="specificFaculty">
              <img
                class="courseImage"
                :src="this.specificFaculty.profileImage"
              />
              <p>{{ specificFaculty.name }}</p>
              <p>{{ specificFaculty.userCount }} members</p>
              <button class="joinButton" @click="joinGroup(specificFaculty)">
                Join Group
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="findSearch" class="findBox">
        <div class="pathRow">
          <div @click="goToCourse(onSubject)" class="resetPathLink"></div>
          <div @click="goToSearch()" class="searchPath"></div>
          <input
            id="searchFinder"
            autofocus="autofocus"
            list="searchContent"
            v-model="searchString"
            type="text"
            @focus="focused = true"
            @blur="focused = false"
            placeholder="Search CourseLnk"
            @keydown="checkTime($event)"
            autocomplete="off"
          />
        </div>
        <div class="finderRow isWindow">
          <div v-if="loading" class="loaderContainer">
            <div class="loader"></div>
          </div>
          <div class="fullWidth" v-else>
            <div class="fullWidth" v-if="checkEmpty()">
              <div class="noResult" v-if="searchString.length === 0">
                <img
                  src="@/assets/Icons/StartSearchIcon.svg"
                  height="300"
                  width="300"
                />
                <b>Search for courses, faculties and groups!</b>
              </div>
              <div class="noResult" v-else>
                <img
                  src="@/assets/Icons/EmptyIcon.svg"
                  height="300"
                  width="300"
                />
                <b class="errorMessage"
                  >Can't find the course or program you're looking for? That's
                  on us and we're sorry. Enter the chat we missed and we'll add
                  it as fast as possible</b
                >
                <textarea
                  v-model="missingCourse"
                  placeholder="Name"
                  class="groupDescription small"
                  maxlength="50"
                />
                <div @click="uploadMissingCourse()" class="sendButtonFinder">
                  Send
                </div>
                <div>{{ this.missingFeedback }}</div>
              </div>
            </div>
            <div v-else>
              <p class="finderTitle">Search Result</p>
              <div
                class="finderScrollBoxSearch"
                :class="{ isWindow: isWindows }"
              >
                <ul v-for="(object, index) in totalSearch" :key="index">
                  <li
                    v-if="object.type == 'faculties'"
                    v-on:mousedown="searchCourse(object)"
                    class="profileOption"
                  >
                    <img
                      :src="object.doc.profileImage"
                      class="searchProfileImage"
                    />
                    {{ object.doc.name }}<br />
                    Faculty
                  </li>
                  <li
                    v-if="object.type == 'courses'"
                    v-on:mousedown="searchCourse(object)"
                    class="profileOption"
                  >
                    <img
                      :src="object.doc.profileImage"
                      class="searchProfileImage"
                    />
                    {{ object.doc.name }}<br />
                    Course
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Navbar from "@/components/Navbar";
import db from "@/db";
import firebase from "@/firebase";
import GroupPreview from "@/components/group/GroupPreview.vue";
import CreateGroup from "@/components/group/CreateGroup.vue";

export default {
  mounted() {
    this.init();
    this.isWindows = this.checkOS();
  },

  components: {
    Navbar,
    GroupPreview,
    CreateGroup,
  },

  data: () => ({
    findCourse: true,
    findFaculty: false,
    findSearch: false,
    isShowingSubjects: true,
    subjects: [],
    subject: "",
    courses: [],
    faculties: [],
    specificCourse: null,
    specificFaculty: null,
    onSubject: "",
    onCourse: "",
    onFaculty: "",
    isWindows: false,
    searchString: "",
    doneTyping: false,
    loading: false,
    totalSearch: [],
    focused: false,
    missingFeedback: "",
  }),

  computed: {
    ...mapState("user", ["user"]),
    ...mapState("messageBoard", [
      "searchingGroup",
      "groupPreview",
      "creatingGroup",
    ]),
  },
  watch: {
    doneTyping() {
      if (this.doneTyping) {
        if (this.searchString.length != 0) {
          this.loading = true;
          var lowerString = this.searchString.toLowerCase();
          this.searchArray = lowerString.split(/(?:-| )+/);
          this.searchDatabase();
        } else {
          this.totalSearch;
        }
      }
    },
  },

  methods: {
    ...mapActions("groups", [
      "fetchCourses",
      "fetchSubjects",
      "fetchFaculties",
      "fetchGroups",
      "subscribeToTopic",

      "fetchGroupsForSubject",
    ]),
    ...mapActions("user", ["updateUserGroups"]),

    checkOS() {
      if (navigator.appVersion.indexOf("Win") != -1) {
        return true;
      }
      return false;
    },
    createGroup() {
      this.$store.commit("messageBoard/setCreateGroup", true);
    },
    cancelPreview(event) {
      if (event.target.className == "previewContainer") {
        this.$store.commit("messageBoard/setSearchGroup", false);
        this.$store.commit("messageBoard/setCreateGroup", false);
      }
    },
    checkTime(event) {
      var keycode = event.keyCode;
      if (
        (keycode > 47 && keycode < 58) || // number keys
        keycode == 32 ||
        keycode == 8 ||
        keycode == 13 || // spacebar/backspace & return key(s) (if you want to allow carriage returns)
        (keycode > 64 && keycode < 91) || // letter keys
        (keycode > 95 && keycode < 112) || // numpad keys
        (keycode > 185 && keycode < 193) || // ;=,-./` (in order)
        (keycode > 218 && keycode < 223) // [\]' (in order)
      ) {
        this.doneTyping = false;
        setTimeout(() => {
          this.doneTyping = true;
        }, 500);
      }
    },

    async searchDatabase() {
      console.log("searched");
      var totalSearch = [];
      // Search Faculties
      if (!/\d/.test(this.searchString)) {
        await db
          .collection("faculties")
          .where("school_id", "==", this.user.school_id)
          .where("keywords", "array-contains-any", this.searchArray)
          .limit(2)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                searchResult: doc.data().name,
                type: "faculties",
                id: doc.id,
              };
              totalSearch.push(data);
            });
          });
      }
      // Search Groups
      await db
        .collection("groups")
        .where("school_id", "==", this.user.school_id)
        .where("keywords", "array-contains-any", this.searchArray)
        .where("privacyType", "!=", "secret")
        .limit(10)
        .get()
        .then((docs) => {
          docs.forEach((doc) => {
            let data = {
              doc: doc.data(),
              searchResult: doc.data().name,
              type: "groups",
              id: doc.id,
            };
            totalSearch.push(data);
          });
        });

      // Search Courses
      if (this.searchArray.length > 1) {
        await db
          .collection("courses")
          .where("school_id", "==", this.user.school_id)
          .where(
            "letterKeywords",
            "array-contains",
            this.searchString.toLowerCase()
          )
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                id: doc.id,
                searchResult: doc.data().name,
                type: "courses",
              };
              totalSearch.push(data);
            });
          });
        await db
          .collection("courses")
          .where("school_id", "==", this.user.school_id)
          .where("letterKeywords", "array-contains-any", this.searchArray)
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              if (totalSearch.findIndex((x) => x.id == doc.id) == -1) {
                let data = {
                  doc: doc.data(),
                  searchResult: doc.data().name,
                  type: "courses",
                  id: doc.id,
                };
                totalSearch.push(data);
              }
            });
          });
      } else {
        await db
          .collection("courses")
          .where("school_id", "==", this.user.school_id)
          .where("letterKeywords", "array-contains-any", this.searchArray)
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                searchResult: doc.data().name,
                type: "courses",
                id: doc.id,
              };
              totalSearch.push(data);
            });
          });
        await db
          .collection("courses")
          .where("school_id", "==", this.user.school_id)
          .where("numberKeywords", "array-contains-any", this.searchArray)
          .limit(10)
          .get()
          .then((docs) => {
            docs.forEach((doc) => {
              let data = {
                doc: doc.data(),
                searchResult: doc.data().numberKeywords[
                  doc.data().numberKeywords.length - 1
                ],
                type: "courses",
                id: doc.id,
              };
              totalSearch.push(data);
            });
          });
      }

      // Sort search based on relevency
      var sortedSearch = [];
      for (var option = 0; option < totalSearch.length; option++) {
        let relevency = this.commonChars(
          totalSearch[option].searchResult,
          this.searchString
        );
        totalSearch[option].relevency = relevency / this.searchString.length;
        if (relevency / this.searchString.length > 0.4) {
          sortedSearch.push(totalSearch[option]);
        }
      }
      sortedSearch.sort((a, b) => b.relevency - a.relevency);
      this.loading = false;
      this.doneTyping = false;
      this.totalSearch = sortedSearch.slice(0, 15);
    },

    commonChars(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();
      s1 = s1.split(" ");
      s2 = s2.split(" ");
      let seenChars = [];
      let shortStr;
      let longStr;
      let counter = 0;

      if (s1.length < s2.length) {
        shortStr = s1;
        longStr = s2;
      } else {
        shortStr = s2;
        longStr = s1;
      }

      for (let i = 0; i < shortStr.length; i++) {
        var shortWord;
        var longWord;
        if (shortStr[i].length < longStr[i].length) {
          shortWord = shortStr[i];
          longWord = longStr[i];
        } else {
          shortWord = longStr[i];
          longWord = shortStr[i];
        }
        for (let j = 0; j < shortWord.length; j++) {
          if (
            longWord.indexOf(shortWord[j]) !== -1 &&
            !seenChars.includes(shortWord[j])
          ) {
            counter++;
            seenChars.push(shortWord[j]);
          }
        }
      }
      return counter;
    },
    searchCourse(course) {
      if (this.user.courses.findIndex((x) => x.id === course.id) != -1) {
        var name = course.searchResult.replace(" ", "-");
        this.$router.replace({
          name: "MessageBoard",
          params: { name: name, id: course.id, type: course.type },
        });
        this.$router.go();
      } else {
        db.collection(course.type)
          .doc(course.id)
          .get()
          .then((doc) => {
            var previewCourse = doc.data();
            previewCourse.type = course.type;
            previewCourse.id = course.id;
            this.$store.commit("messageBoard/setGroupPreview", previewCourse);
            this.$store.commit("messageBoard/setSearchGroup", true);
          });
      }
    },
    checkEmpty() {
      return !this.totalSearch.length;
    },
    async init() {
      this.type = "Course";
      this.subjects = await this.fetchSubjects(this.user.school_id);
      this.faculties = await this.fetchFaculties(this.user.school_id);

      /*} else if (this.isFaculty) {
        this.groups = await this.fetchFaculties(this.user.school_id);
      } else {
        this.type = "Group";
      }*/
    },

    async showCourses(subject) {
      this.subject = subject;
      this.$store.commit("groups/setIsShowingSubjects", false);
      var info = {
        school_id: this.user.school_id,
        subject: subject,
      };

      this.specificCourse = null;
      this.onSubject = subject;
      this.onCourse = "";
      this.courses = await this.fetchCourses(info);
    },

    async showInfo(course) {
      this.onCourse = course.name;
      this.specificCourse = course;
      this.specificCourse.userCount = this.specificCourse.userCount
        ? this.specificCourse.userCount
        : 0;
      this.specificCourse.type = "courses";
    },
    async showFacultyInfo(faculty) {
      this.onFaculty = faculty.name;
      this.specificFaculty = faculty;
      this.specificFaculty.userCount = this.specificFaculty.userCount
        ? this.specificFaculty.userCount
        : 0;
      this.specificFaculty.type = "faculties";
    },
    async selectCourse(object) {
      console.log(object);
    },
    goToCourse() {
      this.findCourse = true;
      this.findFaculty = false;
      this.findSearch = false;

      this.onSubject = "";
      this.onCourse = "";
      this.courses = null;
      this.specificCourse = null;
    },
    goToFaculty() {
      this.findCourse = false;
      this.findFaculty = true;
      this.findSearch = false;

      this.onFaculty = "";
      this.specificFaculty = null;
    },
    goToSearch() {
      this.findCourse = false;
      this.findFaculty = false;
      this.findSearch = true;
    },
    joinGroup(group) {
      let data = {
        name: this.user.firstName + " " + this.user.lastName,
        profileImage: this.user.profileImage,
        user_id: this.user.id,
      };
      group.recentPosts = !group.recentPosts ? [] : group.recentPosts;

      if (group.type == "courses") {
        this.user.courses.push({
          name: group.name,
          id: group.id,
          lastVisited: Date.now(),
          notificationsEnabled: true,
          subject: group.subject,
          recentPosts: group.recentPosts,
          users: group.users,
          hasSeenLastPost: group.hasSeenLastPost,
          type: "courses",
        });
        this.user.course_ids.push(group.id);
      } else {
        this.user.faculties.push({
          name: group.name,
          id: group.id,
          lastVisited: Date.now(),
          notificationsEnabled: true,
          recentPosts: group.recentPosts,
          users: group.users,
          hasSeenLastPost: group.hasSeenLastPost,
          type: "faculties",
        });
        this.user.faculty_ids.push(group.id);
      }

      db.collection(group.type)
        .doc(group.id)
        .update({
          users: firebase.firestore.FieldValue.arrayUnion(data),
          userCount: firebase.firestore.FieldValue.increment(1),
        });

      this.$store.commit("messageBoard/setGroupId", group.id);
      this.$store.commit("messageBoard/setGroupName", group.name);
      this.$store.commit("messageBoard/setGroupType", group.type);
      this.$store.commit("messageBoard/setCurGroup", group);
      this.$store.commit("user/setUser", this.user);
      this.updateUserGroups();
      this.subscribeToTopic({ groupId: group.id, user: this.user });

      var joinedContent =
        this.user.firstName + " " + this.user.lastName + " joined the group";

      this.addUserJoinedGroupPost(joinedContent, group);

      this.$router.push({
        name: "MessageBoard",
        params: {
          name: group.name,
          id: group.id,
          type: group.type,
        },
      });
      this.$store.commit("messageBoard/setGroupPreview", undefined);
      this.$store.commit("messageBoard/setSearchGroup", false);
    },
    uploadMissingCourse() {
      db.collection("missingCourses").add({
        course: this.missingCourse,
        school_Id: this.user.school_id,
        userId: this.user.id,
      });
      this.missingCourse = "";
      this.missingFeedback =
        "Thank you for your feedback, we will add your course as soon as we can";
    },
    addUserJoinedGroupPost(content, group) {
      const id = "p" + db.collection("posts").doc().id;
      db.collection("posts")
        .doc(id)
        .set({
          content: content,
          chat_id: group.id,
          created_at: Date.now(),
        });
      group.recentPosts.push({
        content: content,
        created_at: Date.now(),
        id: id,
      });
      while (group.recentPosts.length > 25) {
        group.recentPosts.splice(0, 1);
      }

      db.collection(group.type)
        .doc(group.id)
        .update({
          recentPosts: group.recentPosts,
        });
    },
  },
};
</script>

<style src="@/styles/views/AddCourse.css"></style>
